module.exports = __webpack_public_path__ + "static/img/Hualien-econstruction_03.1a7f216.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/fight-epidemic/Hualien-econstruction_03.jpg
// module id = nqMO
// module chunks = 98